import { render } from "./PortalParticles.vue?vue&type=template&id=09fda6f2&scoped=true"
import script from "./PortalParticles.vue?vue&type=script&lang=js"
export * from "./PortalParticles.vue?vue&type=script&lang=js"

import "./PortalParticles.vue?vue&type=style&index=0&id=09fda6f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fda6f2"]])

export default __exports__